// @ts-nocheck
import { ExtractArray } from "@toolkit/Framework/Types/Common";
import isArray from "lodash/isArray";

const itemsToArray = <T>(items: T): ExtractArray<T> | undefined => {
    return items ? ((isArray(items) ? items : [items]) as ExtractArray<T>) : undefined;
};

export default itemsToArray;
